import React from 'react';

export function OnlineIndicator({ isOnline, size = 'sm' }) {
  const sizeClass = size === 'xs' ? 'w-2 h-2' : size === 'sm' ? 'w-2.5 h-2.5' : 'w-3 h-3';
  return (
    <span
      data-testid={`online-indicator-${isOnline ? 'online' : 'offline'}`}
      className={`inline-block ${sizeClass} rounded-full shrink-0 ${
        isOnline
          ? 'bg-green-500 shadow-[0_0_6px_rgba(34,197,94,0.5)]'
          : 'bg-gray-300 dark:bg-gray-600'
      }`}
    />
  );
}
